import DefaultElementNodeType from '../DefaultElementNodeType';
import {PHYSICAL_FACILITY} from '../../metamodel/Concept';

export default class FacilityNodeType extends DefaultElementNodeType {
	static get typeName() {
		return PHYSICAL_FACILITY;
	}
}
